import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class OrderStatusStore extends EventEmitter {
    PageLoadData = "";
    ApprovalHistoryData = "";
    PODetailData = "";
    cartOrderSuccess = "";
    Excel = "";
    PassThroughAuthe = "";
    CancelRequest = "";
    HeaderData = "";
    LineData = "";
    ApproverList = "";
    RemainderData = "";
    PickupRslt = "";
    ReprintResponse = "";
    coreDetailsResponse = "";
    SubmitReturn = "";
    StartAReturn = "";
    notesList = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleOrderStatusStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.OrderStatus_PageLoad: {
                this.PageLoadData = action.action.response;
                ;
                this.emit('OrdStatusload');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_btnSavePrefs_Click: {
                this.PageLoadData = action.action.response;
                ;
                this.emit('SavePreference');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_ApprovalHistory: {
                this.PageLoadData = action.action.response;
                ;
                this.emit('ApprovalHistory');
                break;
            }
            // Order Status Stored Procedure Integration Change - Deepthi
            case "HeaderData": {
                this.HeaderData = action.action.response;
                ;
                this.emit('HeaderData');
                break;
            }
            case "LineData": {
                this.LineData = action.action.response;
                ;
                this.emit('LineData');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_RetrieveOrderData: {
                this.PageLoadData = action.action.response;
                ;
                this.emit('data');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_PoDetails: {
                this.PODetailData = action.action.response;
                this.emit('POdetail');
                break;
            }
            //[2/2/2022, PC_OS_07, WW-350, Dhevanesam R]
            case SDIConstants.methodNames.CancelRequest: {
                this.CancelRequest = action.action.response;
                this.emit('CancelRequest');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_ReorderItems: {
                this.cartOrderSuccess = action.action.response;
                ;
                this.emit('BuyAgain');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_ExportToExcel: {
                this.Excel = action.action.response;
                ;
                this.emit('Export');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_OrderDetail: {
                this.Excel = action.action.response;
                ;
                this.emit('OrderDetail');
                break;
            }
            case SDIConstants.methodNames.OrderStatus_ShipTo: {
                this.Excel = action.action.response;
                ;
                this.emit('shipto');
                break;
            }
            case "ORDERSTS_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "ORDERSTS_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "PassThroughAuthe": {
                this.PassThroughAuthe = action.action.response;
                this.emit('PassThroughAuthe');
                break;
            }
            case "PickupOrder": {
                this.PickupRslt = action.action.response;
                this.emit('PickupOrder');
                break;
            }
            case "ReprintResponse": {
                this.ReprintResponse = action.action.response;
                this.emit('ReprintResponse');
                break;
            }
            case "coreDetailsResponse": {
                this.coreDetailsResponse = action.action.response;
                this.emit('coreDetailsResponse');
                break;
            }
            case "SubmitReturn": {
                this.SubmitReturn = action.action.response;
                this.emit('SubmitReturn');
                break;
            }
            case "ApproverList": {
                this.ApproverList = action.action.response;
                this.emit('ApproverList');
                break;
            }
            case "ApprovalRemainder": {
                this.RemainderData = action.action.response;
                this.emit('ApprovalRemainder');
                break;
            }
            case "StartAReturn": {
                this.StartAReturn = action.action.response;
                this.emit('StartAReturn');
                break;
            }
            case "getNotes": {
                this.notesList = action.action.response;
                this.emit('getNotes');
                break;
            }


        }
    }
}
const objordStatusStore = new OrderStatusStore;
// Dispatcher code
Dispatcher.register(objordStatusStore.handleOrderStatusStore.bind(objordStatusStore));
export default objordStatusStore;